import { css } from '@emotion/css';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ReactComponent as Fuller } from '../../assets/images/logo/logo_fuller.svg';
import { ReactComponent as Nintendo } from '../../assets/images/logo/logo_nintendo.svg';
import { Logo } from '../shared/Logo';
import { TitleHeader } from '../shared/TitleHeader';

const creditStyles = css`
  display: flex;
  flex-direction: column;
  background-color: #f5f1e3;
  font-size: 14px;
  width: 100%;
  height: 100%;
  overflow-y: scroll;

  .body {
    flex: 1 1 auto;
    width: 100%;
    max-width: 480px;
    overflow-y: scroll;
    margin: 0 auto;
    padding: 0 20px;
  }
  .body::-webkit-scrollbar {
    display: none;
  }
  .logo {
    padding: 48px 0;
  }
  section {
    margin: 24px 0 40px;
  }
  section li {
    margin: 4px 0;
  }
  h3 {
    color: #938666;
    font-size: 14px;
    margin: 0 0 8px;
  }
  ul {
    margin: 0 0 24px;
    padding: 0;
    list-style: none;
  }
  footer {
    flex: 0 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .images {
    display: flex;
    justify-content: center;
    align-items: flex-end;
  }
`;

interface Text {
  en: string;
  ja: string;
}

interface Titles {
  director: Text;
  designer: Text;
  engineer: Text;
  planner: Text;
  designSupervisor: Text;
  debug: Text;
  localization: Text;
}

interface CreditData {
  fuller: {
    directors: Text[];
    designers: Text[];
    engineers: Text[];
  };
  nintendo: {
    planner: Text[];
    designSupervisors: Text[];
    engineers1: Text[];
    engineers2: Text[];
    debug: Text[];
    localization1: Text[];
    localization2: Text[];
    localization3: Text[];
    localization4: Text[];
    localization5: Text[];
    localization6: Text[];
  };
}

const titles: Titles = {
  director: { en: 'Directors', ja: 'ディレクター' },
  designer: { en: 'Designers', ja: 'デザイナー' },
  engineer: { en: 'Engineers', ja: 'エンジニア' },
  planner: { en: 'Planners', ja: 'プランナー' },
  designSupervisor: { en: 'Design Supervisors', ja: 'デザイン監修' },
  debug: { en: 'Testing', ja: 'テスティング' },
  localization: { en: 'Localization', ja: 'ローカライズ' }
};

const data: CreditData = {
  fuller: {
    directors: [
      { en: 'Mizuho Hayashi', ja: 'はやし みずほ' },
      { en: 'Hiroyuki Hayashi', ja: 'はやし ひろゆき' },
      { en: 'Tomomi Miyazaki', ja: 'みやざき ともみ' }
    ],
    designers: [
      { en: 'Masashi Yamazaki', ja: 'やまざき まさし' },
      { en: 'Taiki Tanaka', ja: 'たなか たいき' },
      { en: 'Marina Ichinose', ja: 'いちのせ まりな' }
    ],
    engineers: [
      { en: 'Sota Hatakeyama', ja: 'はたけやま そうた' },
      { en: 'Masaya Fukushima', ja: 'ふくしま まさや' },
      { en: 'Kanta Suzuki', ja: 'すずき かんた' },
      { en: 'Aoi Meguro', ja: 'めぐろ あおい' }
    ]
  },
  nintendo: {
    planner: [
      { en: 'Kenichi Nishida', ja: 'にしだ けんいち' },
      { en: 'Yurie Hattori', ja: 'はっとり ゆりえ' },
      { en: 'Keiko Kinoshita', ja: 'きのした けいこ' }
    ],
    designSupervisors: [
      { en: 'Takahiro Nagaya', ja: 'ながや たかひろ' },
      { en: 'Yuka Kumiki', ja: 'くみき ゆか' },
      { en: 'Satomi Tateishi', ja: 'たていし さとみ' },
      { en: 'Yui Takagi', ja: 'たかぎ ゆい' }
    ],
    engineers1: [
      { en: 'Takahiro Yamaguchi', ja: 'やまぐち たかひろ' },
      { en: 'Yusuke Inoue', ja: 'いのうえ ゆうすけ' },
      { en: 'Akira Okazaki', ja: 'おかざき あきら' },
      { en: 'Taiyo Watanabe', ja: 'わたなべ たいよう' },
      { en: 'Yasunari Umano', ja: 'うまの やすなり' },
      { en: 'Shoya Tanaka', ja: 'たなか しょうや' },
      { en: 'Sunao Otake', ja: 'おおたけ すなお' }
    ],
    engineers2: [{ en: 'Hideaki Tanabe', ja: 'たなべ ひであき' }],
    debug: [
      { en: 'Mario Club Co., Ltd.', ja: 'マリオクラブ株式会社' },
      { en: 'Pole To Win, Inc.', ja: 'ポールトゥウィン株式会社' },
      { en: 'NOA Product Testing Department', ja: 'NOA Product Testing Department' },
      { en: 'NOE Quality Assurance', ja: 'NOE Quality Assurance' },
      { en: 'ASIAN LANGUAGE QA', ja: 'ASIAN LANGUAGE QA' }
    ],
    localization1: [
      { en: 'Winda Benedetti', ja: 'Winda Benedetti' },
      { en: 'Kris Copeland', ja: 'Kris Copeland' },
      { en: 'Marjolaine Drouin', ja: 'Marjolaine Drouin' },
      { en: 'Yunica Hara', ja: 'Yunica Hara' },
      { en: 'Bill Hutchens', ja: 'Bill Hutchens' },
      { en: 'Noriko Kaji', ja: 'Noriko Kaji' },
      { en: 'Sol Plata Loera', ja: 'Sol Plata Loera' },
      { en: 'Elina Sánchez', ja: 'Elina Sánchez' },
      { en: 'Taryn Ziegler', ja: 'Taryn Ziegler' },
      { en: 'Amanda Barrera', ja: 'Amanda Barrera' },
      { en: 'Sam Barrett-Farris', ja: 'Sam Barrett-Farris' },
      { en: 'Jordon Galloway', ja: 'Jordon Galloway' },
      { en: 'Zaher Khan', ja: 'Zaher Khan' },
      { en: 'Brette Levitan', ja: 'Brette Levitan' },
      { en: 'Kane Magnus Ham', ja: 'Kane Magnus Ham' },
      { en: 'Paloma Martínez Osuna', ja: 'Paloma Martínez Osuna' },
      { en: 'Emily Minakata', ja: 'Emily Minakata' },
      { en: 'Pascal Ramirez', ja: 'Pascal Ramirez' },
      { en: 'Kay Saviskas', ja: 'Kay Saviskas' },
      { en: 'Chihiro Sekiguchi', ja: 'Chihiro Sekiguchi' },
      { en: 'Makiko Szolas', ja: 'Makiko Szolas' },
      { en: 'Laura Vinado', ja: 'Laura Vinado' },
      { en: 'Andrew Wang', ja: 'Andrew Wang' },
      { en: 'Pamela Waters', ja: 'Pamela Waters' },
      { en: 'Karen Yuen', ja: 'Karen Yuen' }
    ],
    localization2: [
      { en: 'Luke Allardyce', ja: 'Luke Allardyce' },
      { en: 'Federico Maggi', ja: 'Federico Maggi' },
      { en: 'Sarah Nojiri', ja: 'Sarah Nojiri' },
      { en: 'Michael Frisch', ja: 'Michael Frisch' },
      { en: 'Petra Gyarmaty', ja: 'Petra Gyarmaty' },
      { en: 'Jo Legge', ja: 'Jo Legge' },
      { en: 'Sylvain Gsell', ja: 'Sylvain Gsell' },
      { en: 'Claire Da Cunha Belves', ja: 'Claire Da Cunha Belves' },
      { en: 'Marco Morbin', ja: 'Marco Morbin' },
      { en: 'Valeria Castellino', ja: 'Valeria Castellino' },
      { en: 'Adriano Antonini', ja: 'Adriano Antonini' },
      { en: 'Arne Glinka', ja: 'Arne Glinka' },
      { en: 'Sven Pötzl', ja: 'Sven Pötzl' },
      { en: 'Hannah Siebert', ja: 'Hannah Siebert' },
      { en: 'Álex Hernández-Puertas', ja: 'Álex Hernández-Puertas' },
      { en: 'Ariel del Rio de Angelis', ja: 'Ariel del Rio de Angelis' },
      { en: 'Suzanne Turgeon', ja: 'Suzanne Turgeon' },
      { en: 'Marijke Pustjens', ja: 'Marijke Pustjens' },
      { en: 'Erik Nusselder', ja: 'Erik Nusselder' },
      { en: 'Anton Ivanchikov', ja: 'Anton Ivanchikov' },
      { en: 'Polina Shenoeva', ja: 'Polina Shenoeva' },
      { en: 'Victoria Valeria Becker', ja: 'Victoria Valeria Becker' },
      { en: 'Jasmijn Cremers', ja: 'Jasmijn Cremers' },
      { en: 'Ahmed Bounouar', ja: 'Ahmed Bounouar' },
      { en: 'Veronica Casi', ja: 'Veronica Casi' },
      { en: 'Manuel Tants', ja: 'Manuel Tants' },
      { en: 'Adriana Villamisar Naveira', ja: 'Adriana Villamisar Naveira' },
      { en: 'Yoram Schipper', ja: 'Yoram Schipper' },
      { en: 'Ekaterina Ulrich', ja: 'Ekaterina Ulrich' }
    ],
    localization3: [{ en: 'Chen Yufeng', ja: 'Chen Yufeng' }],
    localization4: [
      { en: 'Claudia Chan', ja: 'Claudia Chan' },
      { en: 'Jeanie Ho', ja: 'Jeanie Ho' },
      { en: 'Takaaki Ueno', ja: 'Takaaki Ueno' },
      { en: 'Wang Chunglong', ja: 'Wang Chunglong' },
      { en: 'Hsu Chingya', ja: 'Hsu Chingya' },
      { en: 'Tanya Tan', ja: 'Tanya Tan' }
    ],
    localization5: [
      { en: 'Qiu Xiaochun', ja: 'Qiu Xiaochun' },
      { en: 'Ling Yayun', ja: 'Ling Yayun' },
      { en: 'Misa Matsumoto', ja: 'Misa Matsumoto' },
      { en: 'Xu Ming', ja: 'Xu Ming' },
      { en: 'Pu Xinyi', ja: 'Pu Xinyi' }
    ],
    localization6: [
      { en: 'Dongyeon Kim', ja: 'Dongyeon Kim' },
      { en: 'Kyoungim Na', ja: 'Kyoungim Na' },
      { en: 'Yunjin Park', ja: 'Yunjin Park' }
    ]
  }
};

export const Credit: React.FC = () => {
  const { t, i18n } = useTranslation('settings');
  return (
    <main className={creditStyles}>
      <TitleHeader title={t('credit')} color="#dbcca7" backLabel={t('aria_back_to_settings')} />
      <div className="body">
        <div className="logo">
          <Logo scale={1.2} />
        </div>

        <section>
          <h2 aria-label="Fuller, Inc.">
            <Fuller />
          </h2>
          <section>
            <h3>{titles.director[i18n.language === 'ja-JP' ? 'ja' : 'en']}</h3>
            <ul>
              {data.fuller.directors.map((v, i) => (
                <li key={`${i}`}>{v[i18n.language === 'ja-JP' ? 'ja' : 'en']}</li>
              ))}
            </ul>
          </section>

          <section>
            <h3>{titles.designer[i18n.language === 'ja-JP' ? 'ja' : 'en']}</h3>
            <ul>
              {data.fuller.designers.map((v, i) => (
                <li key={`${i}`}>{v[i18n.language === 'ja-JP' ? 'ja' : 'en']}</li>
              ))}
            </ul>
          </section>

          <section>
            <h3>{titles.engineer[i18n.language === 'ja-JP' ? 'ja' : 'en']}</h3>
            <ul>
              {data.fuller.engineers.map((v, i) => (
                <li key={`${i}`}>{v[i18n.language === 'ja-JP' ? 'ja' : 'en']}</li>
              ))}
            </ul>
          </section>
        </section>

        <section>
          <h2 aria-label="Nintendo">
            <Nintendo />
          </h2>

          <section>
            <h3>{titles.planner[i18n.language === 'ja-JP' ? 'ja' : 'en']}</h3>
            <ul>
              {data.nintendo.planner.map((v, i) => (
                <li key={`${i}`}>{v[i18n.language === 'ja-JP' ? 'ja' : 'en']}</li>
              ))}
            </ul>
          </section>

          <section>
            <h3>{titles.designSupervisor[i18n.language === 'ja-JP' ? 'ja' : 'en']}</h3>
            <ul>
              {data.nintendo.designSupervisors.map((v, i) => (
                <li key={`${i}`}>{v[i18n.language === 'ja-JP' ? 'ja' : 'en']}</li>
              ))}
            </ul>
          </section>

          <section>
            <h3>{titles.engineer[i18n.language === 'ja-JP' ? 'ja' : 'en']}</h3>
            <ul>
              {data.nintendo.engineers1.map((v, i) => (
                <li key={`${i}`}>{v[i18n.language === 'ja-JP' ? 'ja' : 'en']}</li>
              ))}
            </ul>
            <ul>
              {data.nintendo.engineers2.map((v, i) => (
                <li key={`${i}`}>{v[i18n.language === 'ja-JP' ? 'ja' : 'en']}</li>
              ))}
            </ul>
          </section>

          <section>
            <h3>{titles.debug[i18n.language === 'ja-JP' ? 'ja' : 'en']}</h3>
            <ul>
              {data.nintendo.debug.map((v, i) => (
                <li key={`${i}`}>{v[i18n.language === 'ja-JP' ? 'ja' : 'en']}</li>
              ))}
            </ul>
          </section>

          <section>
            <h3>{titles.localization[i18n.language === 'ja-JP' ? 'ja' : 'en']}</h3>
            <ul>
              {data.nintendo.localization1.map((v, i) => (
                <li key={`${i}`}>{v[i18n.language === 'ja-JP' ? 'ja' : 'en']}</li>
              ))}
            </ul>
            <ul>
              {data.nintendo.localization2.map((v, i) => (
                <li key={`${i}`}>{v[i18n.language === 'ja-JP' ? 'ja' : 'en']}</li>
              ))}
            </ul>
            <ul>
              {data.nintendo.localization3.map((v, i) => (
                <li key={`${i}`}>{v[i18n.language === 'ja-JP' ? 'ja' : 'en']}</li>
              ))}
            </ul>
            <ul>
              {data.nintendo.localization4.map((v, i) => (
                <li key={`${i}`}>{v[i18n.language === 'ja-JP' ? 'ja' : 'en']}</li>
              ))}
            </ul>
            <ul>
              {data.nintendo.localization5.map((v, i) => (
                <li key={`${i}`}>{v[i18n.language === 'ja-JP' ? 'ja' : 'en']}</li>
              ))}
            </ul>
            <ul>
              {data.nintendo.localization6.map((v, i) => (
                <li key={`${i}`}>{v[i18n.language === 'ja-JP' ? 'ja' : 'en']}</li>
              ))}
            </ul>
          </section>
        </section>

        <footer>
          <div className="images">
            <img
              srcSet="/images/credit/img_tsubukichi-2x.png 2x, /images/credit/img_tsubukichi.png 1x"
              alt=""
            />
            <img
              srcSet="/images/credit/img_tanukichi-2x.png 2x, /images/credit/img_tanukichi.png 1x"
              alt=""
            />
            <img
              srcSet="/images/credit/img_mamekichi-2x.png 2x, /images/credit/img_mamekichi.png 1x"
              alt=""
            />
          </div>
        </footer>
      </div>
    </main>
  );
};
